// extracted by mini-css-extract-plugin
export default {"editSectionLabel":"SectionLabel_editSectionLabel__U3D8z"};